import React, { Component } from 'react'
import { connect } from 'react-redux'


import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'

import { dirtyRead } from 'selectors/common'
import { propertyOpenProjects } from 'selectors/project'
import { projects } from 'selectors/entities'

import ProjectList from './List'
import EntityAttachments from 'components/EntityAttachments'
import dataActions from 'actions/dataActions'
import Section from 'components/Section'
import AddButton from 'components/AddButton'

let select = dirtyRead((state, props) => ({
	propertyOpenProjects: propertyOpenProjects(state, props.propertyID)
}))

export class Projects extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="property/projects"
				title="Open projects"
				badge={props.propertyOpenProjects.length}
				top={props.top}
				rightButton={
					<AddButton object={{ type:"project", propertyID: props.propertyID }} />
				}
			>
				<ProjectList propertyID={props.propertyID} />
			</Section>
		)
	}
}

export default connect(select, dataActions)(Projects)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/projects/index.js